import moment from "moment/moment";
import $ from 'jquery';
import 'table2excel';
import 'table2csv';
import jsPDF from 'jspdf'
import 'jspdf-autotable'

class TableExportController {
  constructor($scope) {
      "ngInject";
      this.name = 'tableExport';
      this.scope = $scope;
      this.excelExporter = new Table2Excel();


  }

  exportExcel(){
    this.disablePagination();
    let x = new Table2Excel({defaultFileName: this.getFileName()});
    let table = $(this.tableName);
    x.export(table);
    this.enablePagination();
  }

  exportCsv(){
    this.disablePagination();
    $("#results").table2csv('download', {filename: this.getFileName()+'.csv'});
    this.enablePagination();
  }

  exportPdf() {
    this.disablePagination();
    var doc = new jsPDF();
    doc.autoTable({ html: this.tableName });
    doc.save(this.getFileName()+'.pdf');
    this.enablePagination();
  }


  getFileName() {
    let x = moment().format("MMDDYYYY")

    return this.fileName+'_'+x;
  }

  disablePagination(){
    var pageSize = 10000;
    $('.footable').data('page-size', pageSize);
    $('.footable').trigger('footable_initialized');
  }

  enablePagination(){
    $('.footable').data('page-size', 25);
    $('.footable').trigger('footable_initialized');
  }


}

export default TableExportController;



// WEBPACK FOOTER //
// ./client/common/tableExport/tableExport.controller.js